import { menuControlFor, activeMenuControlFor, toolbarFor } from './_get_menu_control';
import { CanonicalColor, colorHex } from './_color_hex';

const syncMenu = ({ editor }) => {
  const color = editor.getAttributes('textStyle').color;
  const hex = colorHex(color || '#000000').toLowerCase();
  const toolbar = toolbarFor(editor);

  const colorInput = toolbar?.querySelector('input[data-command="text:color"]');
  if (colorInput) {
    colorInput.value = hex;
  }

  const currentSwatch = toolbar?.querySelector('.text-color-control__current');
  if (currentSwatch) {
    currentSwatch.style.backgroundColor = hex;
  }

  const previousControl = activeMenuControlFor(editor, 'text:color');
  const currentControl = color ? menuControlFor(editor, 'text:color', hex) : null;

  if (previousControl !== currentControl) {
    previousControl?.classList?.toggle('active', false);
    currentControl?.classList?.toggle('active', true);
  }
};

export default [
  CanonicalColor.extend({
    onSelectionUpdate: syncMenu,
    onTransaction: syncMenu,
  }),
];
